import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

type Props = {
	modeList: string[];
	changeMode: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
	selectedMode: string;
};

const modes: { [x: string]: string } = {
	ON: 'Онлайн',
	OF: 'Личный прием',
};

export const ModeSelector: React.FC<Props> = ({ modeList, changeMode, selectedMode }) => {
	return (
		<FormControl>
			<RadioGroup row value={selectedMode} onChange={changeMode}>
				{modeList.map((mode) => (
					<FormControlLabel
						key={mode}
						value={mode}
						control={<Radio size="small" />}
						label={<span style={{ fontSize: '14px' }}>{modes[mode]}</span>}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
};
